import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {FilterCard} from './';

import RadioButtons from 'src/components/lib/radio-buttons/radio-buttons';

import css from './sent-card.css';


type SentCardProps = {
  value?: string;
  onChange: (value: string) => unknown;
};

const SentCard = ({value = 'sent_only', onChange}: SentCardProps) => {
  const {t} = useLabelTranslation();
  return (
    <FilterCard header={t('Show', 'Show')} className={css.sentCardBox}>
      <RadioButtons
        name="Sent?"
        selectedValue={value}
        onChange={onChange}
        options={[
          {value: 'skipped_only', label: t('Skipped', 'Skipped')},
          {value: 'sent_only', label: t('Sent', 'Sent')},
        ]}
        className={css.filterRadioButtons}
      />
    </FilterCard>
  );
};

export default SentCard;

export const SentSetToBothCard = () => (
  <SentReasonCard body={'Set "sent?" to skipped or sent'} />
);

export function SentReasonCard({body}: {body: string}) {
  const {t} = useLabelTranslation();
  return (
    <FilterCard
      header={t('To_enable_filter', 'To enable filter')}
      className={css.sentCardBox}
    >
      <div className={css.sentErrorCard}>
        <p>{body}</p>
      </div>
    </FilterCard>
  );
}
